/**
 * contextAnalysisCost.ts — цена платного разбора контекста проекта.
 * Ревизия пачки 9, Ф11.
 *
 * ЗАЧЕМ ОТДЕЛЬНЫЙ МОДУЛЬ. Формула набрана была ДВАЖДЫ — в мастере создания
 * проекта (CreateProjectWizard) и на вкладке «Контекст»
 * (ProjectContextSection), — и обе копии складывали одни и те же две операции
 * розничного каталога. Это денежное число на экране: разъедься копии (в
 * каталоге появится третья операция разбора, одну из двух переименуют) — и на
 * двух экранах одного продукта человеку назовут РАЗНУЮ цену одного действия.
 * Ровно тот класс, ради которого заведено правило двух концов (WEB-1844).
 *
 * ЧТО СКЛАДЫВАЕТСЯ. Разбор страницы приложения — две проводки розничного
 * каталога (backend `cost/cost-catalog-retail.ts`): разбор картинки
 * (`context_vision`) и разбор текста моделью (`context_llm_infer`). Своих
 * чисел здесь нет и быть не может: цены приходят каталогом с сервера.
 *
 * КАТАЛОГ НЕ ЗАГРУЖЕН — ЦЕНЫ НЕТ. Возвращаем null, и вызывающий просто не
 * называет число: молчать честнее, чем показать ноль или устаревшую цифру.
 */

/** Операции розничного каталога, из которых складывается разбор контекста. */
export const CONTEXT_ANALYSIS_COST_KEYS = [
  'context_vision',
  'context_llm_infer',
] as const;

/**
 * Цена одного разбора контекста в кредитах (1 Cr = $0.01, см. utils/credits).
 * Каталог не загружен → null.
 *
 * Отсутствующий ключ считается нулём — так было в обеих прежних копиях, и это
 * осознанно: каталог мог отдать не все операции, а завышать цену выдумкой
 * нельзя. Недостающая операция всплывёт на списании, а не в подписи.
 */
export function contextAnalysisCost(
  costCatalog: Record<string, number> | null | undefined,
): number | null {
  if (!costCatalog) return null;
  return CONTEXT_ANALYSIS_COST_KEYS.reduce(
    (sum, key) => sum + (costCatalog[key] ?? 0),
    0,
  );
}
